import React, { useEffect, useState } from "react";
import styles from "./detailsBox.module.scss";
import SearchInput from "../../Atoms/Inputs/SearchInput";
import FileItem from "../../Atoms/Cards/FileCard";
import { useDownloadAttachment } from "../../../Hooks/Applications";
import { useDeleteFile } from "../../../Hooks/Applications";
import { toast } from "react-toastify";
import downloadiCon from "../../../assets/Imagess/downloadIcon.svg";
import CardImage from "../../../assets/Imagess/calendar.jpg";

import AttachModal from "../../Molecules/Applications/ApplicantModals/attachModal";
import { useToast } from "../Custom/CustomToaster/Toast";
import { isEmpty } from "lodash";
import DeletePopup from "../Custom/DeletePopup";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

function DetailsBox({
  data,
  refetchSingleApplicant,
  selectedFiles,
  setSelectedFiles,
}) {
  const [search, setSearch] = useState();
  const [files, setFiles] = useState(data);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [fileId, setFileId] = useState("");
  const [contentType, setContentType] = useState("");
  const customizedToast = useToast();

  useEffect(() => {
    handleChange();
  }, [search]);

  const handleChange = (Value) => {
    if (!isEmpty(search)) {
      let arr = [...data];
      let array = [];
      for (var i = 0; i < arr.length; i++) {
        if (
          arr[i]["fileName"].toLowerCase().includes(search?.toLowerCase()) ||
          arr[i]["fileType"].toLowerCase().includes(search?.toLowerCase())
        ) {
          array.push(arr[i]);
        }
      }
      setFiles(array);
    }
  };

  //***************** */
  function updateFilesList(FileId) {
    let arr = [...data];
    let array = [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i]["applicantFileId"] !== FileId) {
        array.push(arr[i]);
      }
    }
    setFiles(array);
  }
  //-------------------------------------------------------------

  const downloadAttachment = useDownloadAttachment();

  const handleDownloadFile = async (id) => {
    try {
      const data = await downloadAttachment.mutateAsync(id);
      const url = window.URL.createObjectURL(data.data);
      const link = document.createElement("a");
      link.href = sanitizeAndValidateUrl(url);
      link.download = "File";
      link.click();
      window.URL.revokeObjectURL(url);
      toast.success("Document is Downloaded");
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  //-------------------------------------
  const { mutate: deleteFile, isLoading: isDeleteFile } = useDeleteFile();

  const handleDeleteClick = (FileId) => {
    setFileId(FileId); // Set the file ID for deletion
    setIsDelete(true); // Open the delete confirmation popup
  };

  const handleDeleteFile = (FileId) => {
    deleteFile(FileId, {
      onSuccess: () => {
        setIsDelete(false);
        updateFilesList(FileId);
        customizedToast.open('تم الحذف بنجاح');
        document.getElementById("MoreButton").click();
      },
      onError: (error, data) => {
        // console.error("An error occurred:", error?.response?.data?.message);
        toast.error("An error occurred");
      },
    });
  };
  //-------------------------------------------------------------

  return (
    <div className={`${styles['files-container']}`}>
      <div className={`${styles['row']} ${styles['search-container']}`}>
        <SearchInput
          data={data}
          search={search}
          setSearch={setSearch}
          searchType="Elements"
        />
      </div>
      <div className={`${styles['row']}`}>
        {files &&
          files.map((item, index) => (
            <FileItem
              file={item}
              key={index}
              title={item.fileName.split('.')[0]}
              id={item.applicantFileId}
              type={item.fileType}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              handleDownloadFile={handleDownloadFile}
              handleDeleteFile={handleDeleteFile}
              fileId={fileId}
              setFileId={setFileId}
              setContentType={setContentType}
              ContentType={item.contentType}
              contentType={contentType}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              handleDeleteClick={handleDeleteClick}
            />
          ))}

        {/* {showAttachModal && (
          <AttachModal
            src={CardImage}
            selectedFile={selectedFile}
            downloadiCon={downloadiCon}
            handleOnClose={() => setShowAttachModal(false)}
            handleDownloadFile={handleDownloadFile}
            setFileId={setFileId}
          />
        )} */}
        {isDelete && (
          <DeletePopup
            title="الملف"
            handleOnClose={() => setIsDelete(false)}
            handleDelete={() => handleDeleteFile(fileId)}
            isLoading={isDeleteFile}
          />
        )}
      </div>
    </div>
  );
}

export default DetailsBox;
